'use client';
import { RequireRole } from '../../../components/console-shell';
import { ActivityLedgerWorkspace } from '../../../components/desk/activity-ledger';
export default function ActivityLedgerPage() {
  return <RequireRole roleCode="ACTIVITY_COORDINATOR"><ActivityLedgerWorkspace /></RequireRole>;
}
